import {
  TeacherDeleteLiveClassGroupsDocument,
  TeacherDeleteLiveClassGroupsMutation,
  TeacherDeleteLiveClassGroupsMutationVariables,
  TeacherGetLiveClassGroupsDocument,
  TeacherGetLiveClassGroupsQuery,
  TeacherGetLiveClassGroupsQueryVariables,
  TeacherGetStudentsForGroupByGroupIdDocument,
  TeacherGetStudentsForGroupByGroupIdQuery,
  TeacherGetStudentsForGroupByGroupIdQueryVariables,
  TeacherteacherInsertLiveClassGroupDocument,
  TeacherTeacherInsertLiveClassGroupMutation,
  TeacherTeacherInsertLiveClassGroupMutationVariables,
} from '../types';
import { client } from '../../client';

export async function createGroup(variables: TeacherTeacherInsertLiveClassGroupMutationVariables): Promise<{ id: string }> {
  try {
    const response = await client.mutate<TeacherTeacherInsertLiveClassGroupMutation, TeacherTeacherInsertLiveClassGroupMutationVariables>({
      mutation: TeacherteacherInsertLiveClassGroupDocument,
      variables,
    });
    return response.data.insert_student_groups_one;
  } catch (e) {
    throw e;
  }
}

export async function TeacherGetLiveClassGroups(
  variables: TeacherGetLiveClassGroupsQueryVariables,
): Promise<Array<{ id: string; name: string }>> {
  try {
    const response = await client.query<TeacherGetLiveClassGroupsQuery, TeacherGetLiveClassGroupsQueryVariables>({
      query: TeacherGetLiveClassGroupsDocument,
      variables,
      fetchPolicy: 'network-only',
    });

    return response.data.student_groups;
  } catch (e) {
    throw e;
  }
}

export async function deleteGroup(variables: TeacherDeleteLiveClassGroupsMutationVariables): Promise<number> {
  try {
    const response = await client.mutate<TeacherDeleteLiveClassGroupsMutation, TeacherDeleteLiveClassGroupsMutationVariables>({
      mutation: TeacherDeleteLiveClassGroupsDocument,
      variables,
    });
    return response.data.delete_student_groups.affected_rows;
  } catch (e) {
    throw e;
  }
}

export async function getStudentsByGroupId(
  variables: TeacherGetStudentsForGroupByGroupIdQueryVariables,
): Promise<Array<{ user_id: string }>> {
  try {
    const response = await client.query<TeacherGetStudentsForGroupByGroupIdQuery, TeacherGetStudentsForGroupByGroupIdQueryVariables>({
      query: TeacherGetStudentsForGroupByGroupIdDocument,
      variables,
    });
    return response.data.student_group_users;
  } catch (e) {
    throw e;
  }
}
